import React from 'react';
import { CircularProgress, Grid } from '@mui/material';

export default function LoadingLayout() {
    return (
        <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
            <Grid item xs={12}>
                <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                    <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                        <CircularProgress />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
